export class SpeechResult {
    Word?: string;
    AccuracyScore?: number;
    Correct?: boolean;
    SpeechPhonemeResults?: SpeechPhonemeResult[];
}

export class SpeechPhonemeResult {
    Phoneme?: string;
    AccuracyScore?: number;
}
